// Lightweight in-flight request helper that aggregates callbacks for identical requests
const _inflight = new Map()

export const fetchWithCallbacks = (key, requestFn, cb) => {
  if (!_inflight.has(key)) {
    const entry = { callbacks: [] }
    _inflight.set(key, entry)
    // register callback if provided
    if (typeof cb === 'function') entry.callbacks.push(cb)

    const promise = (async () => {
      try {
        const res = await requestFn()
        try {
          entry.callbacks.forEach(fn => { try { fn(null, res) } catch (_) {} })
        } finally {
          _inflight.delete(key)
        }
        return res
      } catch (err) {
        try {
          entry.callbacks.forEach(fn => { try { fn(err) } catch (_) {} })
        } finally {
          _inflight.delete(key)
        }
        throw err
      }
    })()

    entry.promise = promise
    return promise
  }

  const existing = _inflight.get(key)
  if (typeof cb === 'function') existing.callbacks.push(cb)
  return existing.promise
}

export default {
  fetchWithCallbacks,
}
